import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaRupeeSign } from "react-icons/fa";
import "./styles.scss";

export default function Charges(props) {
  const {
    cartAmount,
    isMobile,
    shippingCharges,
    isStorePickup,
    cartLength,
    codApplied,
  } = props;

  function getChargesRows() {
    let data = [];
    if (!isStorePickup) {
      data.push({ title: "Sub Total", value: cartAmount.toFixed(2) });
    }
    let totalAmount = cartAmount;
    if (shippingCharges > 0) {
      data.push({
        title: "Shipping Charges",
        value: shippingCharges.toFixed(2),
      });
      totalAmount += shippingCharges;
    }

    data.push({ title: "Total Amount", value: totalAmount.toFixed(2) });
    if (isStorePickup && !codApplied) {
      data.push(
        {
          title: "Store Pickup Advance",
          value: (totalAmount * 0.1).toFixed(1),
        },
        {
          title: "Pickup Amount",
          value: totalAmount - totalAmount * 0.1,
        }
      );
    }
    return data.map(
      (element, index) =>
        element.value && (
          <Row
            className={`pt-3 pb-3 ${isMobile ? "" : "pl-3 pr-3"}`}
            key={`charges-${index}`}
          >
            <Col>{element.title}</Col>
            <Col>
              <FaRupeeSign size={isMobile ? 15 : 20} className="mr-1 ml-1" />
              {element.value}
            </Col>
          </Row>
        )
    );
  }

  return (
    <div className="text-center mt-4 mb-4 charges">
      <div className="d-flex justify-content-center align-items-center">
        <Container className="charges-container">
          <Row
            className={`pt-3 pb-3 ${isMobile ? "" : "pl-3 pr-3"}`}
            key={`charges-${10}`}
          >
            <Col>Total Products</Col>
            <Col>{cartLength}</Col>
          </Row>
          {getChargesRows()}
        </Container>
      </div>
    </div>
  );
}
